module.exports = "<p>\n  list-item works!\n</p>\n"